import { render, staticRenderFns } from "./DrawerAttachments.vue?vue&type=template&id=145cf40b"
import script from "./DrawerAttachments.vue?vue&type=script&lang=js"
export * from "./DrawerAttachments.vue?vue&type=script&lang=js"
import style0 from "./DrawerAttachments.vue?vue&type=style&index=0&id=145cf40b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports